(() => {
  const fmtMoney = (c) =>
    "Rp " +
    ((c || 0) / 100).toLocaleString("id-ID", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const SS = "cn_upsell_keys_v1";
  const getKeys = () => {
    try {
      return JSON.parse(sessionStorage.getItem(SS) || "[]");
    } catch {
      return [];
    }
  };
  const setKeys = (arr) => sessionStorage.setItem(SS, JSON.stringify(arr));
  const addKey = (k) => {
    const a = getKeys();
    if (!a.includes(k)) {
      a.push(k);
      setKeys(a);
    }
  };
  const delKey = (k) => setKeys(getKeys().filter((x) => x !== k));

  let busy = false;
  let lastKeysJSON = "";
  let syncTimeout;
  let isProcessingSync = false;

  const $ = (s, r = document) => r.querySelector(s);

  function markSummary() {
    const root = document.getElementById("cart-notification-product");
    if (!root) return;
    const firstVisible = [...root.children].find(
      (el) => el.nodeType === 1 && el.offsetParent !== null,
    );
    if (firstVisible) firstVisible.classList.add("cn-summary");
  }

  function syncResponsiveWrapper() {
    // Prevent concurrent executions
    if (isProcessingSync) return;
    isProcessingSync = true;

    try {
      const root = document.getElementById("cart-notification-product");
      if (!root) return;

      const isMobile = window.matchMedia("(max-width: 480px)").matches;
      const wrapper = root.querySelector(".upsell-modal-notif");

      if (isMobile) {
        if (!wrapper) {
          const img = root.querySelector(".cart-notification-product__image");
          const info = root.querySelector(".product-info-wrapper");
          if (!img || !info) return;

          const w = document.createElement("div");
          w.className = "upsell-modal-notif cn-summary";

          try {
            root.insertBefore(w, img);
            w.appendChild(img);
            w.appendChild(info);
          } catch (e) {
            console.warn("Mobile wrapper creation failed:", e);
            if (w.parentNode) w.remove();
          }
        }
      } else {
        if (wrapper && wrapper.parentNode === root) {
          const img = wrapper.querySelector(
            ".cart-notification-product__image",
          );
          const info = wrapper.querySelector(".product-info-wrapper");

          const fragment = document.createDocumentFragment();

          if (img && wrapper.contains(img)) {
            fragment.appendChild(img);
          }
          if (info && wrapper.contains(info)) {
            fragment.appendChild(info);
          }

          wrapper.remove();

          if (fragment.hasChildNodes()) {
            root.insertBefore(fragment, root.firstChild);
          }

          try {
            [...root.children].forEach(
              (el) => el.classList && el.classList.remove("cn-summary"),
            );
            markSummary();
          } catch (e) {
            console.warn("Class cleanup failed:", e);
          }
        }
      }

      const upsells = root.querySelectorAll(".cn-upsell");
      upsells.forEach((li) => {
        const idx = li.dataset.upsellIndex;
        if (!idx) return;

        const mobileBlock = root.querySelector(
          `.cn-upsell__options-mobile[data-upsell-index="${idx}"]`,
        );
        if (!mobileBlock) return;

        const desktopSelects = Array.from(
          li.querySelectorAll(".js-upsell-opt"),
        ).sort((a, b) => {
          const ai =
            parseInt(a.dataset.optIndex ?? a.getAttribute("data-opt-index")) ||
            0;
          const bi =
            parseInt(b.dataset.optIndex ?? b.getAttribute("data-opt-index")) ||
            0;
          return ai - bi;
        });

        const mobileSelects = Array.from(
          mobileBlock.querySelectorAll(".js-upsell-opt"),
        ).sort((a, b) => {
          const ai =
            parseInt(a.dataset.optIndex ?? a.getAttribute("data-opt-index")) ||
            0;
          const bi =
            parseInt(b.dataset.optIndex ?? b.getAttribute("data-opt-index")) ||
            0;
          return ai - bi;
        });

        if (desktopSelects.length && mobileSelects.length) {
          try {
            desktopSelects.forEach((s, i) => {
              if (mobileSelects[i]) mobileSelects[i].value = s.value;
            });
          } catch (e) {
            console.warn("Select sync failed:", e);
          }
        }
      });
    } catch (error) {
      console.error("syncResponsiveWrapper error:", error);
    } finally {
      isProcessingSync = false;
    }
  }

  function debouncedSyncWrapper() {
    clearTimeout(syncTimeout);
    syncTimeout = setTimeout(syncResponsiveWrapper, 10);
  }

  function resolveVariantId(el) {
    if (!el) return null;

    const upsellIndex =
      el.dataset?.upsellIndex ||
      el.closest("[data-upsell-index]")?.dataset?.upsellIndex ||
      el.closest(".cn-upsell__options-mobile")?.dataset?.upsellIndex ||
      null;
    if (!upsellIndex) {
      console.warn("❌ Tidak ada upsell index di scope (resolveVariantId)", el);
      return null;
    }

    const upsellEl = document.querySelector(
      `.cn-upsell[data-upsell-index="${upsellIndex}"]`,
    );
    if (!upsellEl) {
      console.warn(
        "❌ Tidak bisa menemukan .cn-upsell untuk index",
        upsellIndex,
      );
      return null;
    }

    const variantDataEl = upsellEl.querySelector(".cn-upsell-variants-full");
    if (!variantDataEl) {
      console.warn(
        "❌ Tidak ada .cn-upsell-variants-full di cn-upsell",
        upsellEl,
      );
      return null;
    }

    let variants = [];
    try {
      variants = JSON.parse(variantDataEl.textContent || "[]");
    } catch (err) {
      console.error("❌ Gagal parse JSON varian", err);
      return null;
    }

    const sortSelects = (nodeList) =>
      Array.from(nodeList).sort((a, b) => {
        const ai =
          parseInt(a.dataset.optIndex ?? a.getAttribute("data-opt-index")) || 0;
        const bi =
          parseInt(b.dataset.optIndex ?? b.getAttribute("data-opt-index")) || 0;
        return ai - bi;
      });

    const desktopContainer = upsellEl.querySelector(".cn-upsell__options");
    const desktopSelects = desktopContainer
      ? sortSelects(desktopContainer.querySelectorAll(".js-upsell-opt"))
      : [];

    const mobileBlock = document.querySelector(
      `.cn-upsell__options-mobile[data-upsell-index="${upsellIndex}"]`,
    );
    const mobileSelects = mobileBlock
      ? sortSelects(mobileBlock.querySelectorAll(".js-upsell-opt"))
      : [];

    const mobileVisible = mobileBlock && mobileBlock.offsetParent !== null;
    const desktopVisible =
      desktopContainer && desktopContainer.offsetParent !== null;

    let selectsToUse = [];
    if (mobileVisible && mobileSelects.length) selectsToUse = mobileSelects;
    else if (desktopVisible && desktopSelects.length)
      selectsToUse = desktopSelects;
    else if (desktopSelects.length) selectsToUse = desktopSelects;
    else if (mobileSelects.length) selectsToUse = mobileSelects;
    else selectsToUse = [];

    const selectedOptions = selectsToUse.map((s) =>
      s.value != null ? String(s.value) : "",
    );

    let found = null;
    if (selectedOptions.length) {
      found = variants.find(
        (v) =>
          Array.isArray(v.options) &&
          v.options.length === selectedOptions.length &&
          v.options.every(
            (opt, idx) =>
              String(opt || "")
                .trim()
                .toLowerCase() ===
              String(selectedOptions[idx] || "")
                .trim()
                .toLowerCase(),
          ),
      );
    }

    if (!found && selectedOptions.length) {
      found = variants.find((v) =>
        selectedOptions.every((so) =>
          (v.options || [])
            .map((o) =>
              String(o || "")
                .trim()
                .toLowerCase(),
            )
            .includes(
              String(so || "")
                .trim()
                .toLowerCase(),
            ),
        ),
      );
    }

    if (!found && variants.length) {
      found = variants[0];
    }

    if (!found) {
      console.error(
        "❌ Tidak bisa temukan varian untuk opsi:",
        selectedOptions,
      );
      return null;
    }

    return found.id;
  }

  function copySelectValues(sourceSelects, targetSelects) {
    if (!sourceSelects || !targetSelects) return;
    const len = Math.min(sourceSelects.length, targetSelects.length);
    for (let i = 0; i < len; i++) {
      try {
        targetSelects[i].value = sourceSelects[i].value;
      } catch (e) {}
    }
  }

  function keepOpen() {
    const host = $("cart-notification");
    const panel = $("#cart-notification");
    if (!host || !panel) return;
    host.classList.add("is-visible");
    panel.classList.add("active");
    document.documentElement.classList.add("cn-open");
  }

  async function cart() {
    const r = await fetch("/cart.js");
    return r.json();
  }

  async function add(id, qty) {
    if (!id) throw new Error("❌ variant id kosong saat add");
    const r = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Upsell-Request": "true",
      },
      body: JSON.stringify({ items: [{ id, quantity: qty }] }),
    });
    if (!r.ok) {
      const txt = await r.text();
      console.error("❌ add.js gagal", txt);
      throw new Error("add.js gagal");
    }
    return r.json();
  }

  async function change({ id, key, quantity }) {
    if (!id && !key) return;
    const r = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Upsell-Request": "true",
      },
      body: JSON.stringify(key ? { id: key, quantity } : { id, quantity }),
    });
    if (r.ok) return r.json();

    const u = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Upsell-Request": "true",
      },
      body: JSON.stringify({ updates: { [id]: quantity } }),
    });
    return u.json();
  }

  async function bubble() {
    try {
      const s = await fetch("/?sections=cart-icon-bubble").then((r) =>
        r.json(),
      );
      const b = $("#cart-icon-bubble");
      if (b && s["cart-icon-bubble"]) b.innerHTML = s["cart-icon-bubble"];
    } catch {}
  }

  async function renderAddons(force = false) {
    const wrap = $("#cart-notification-addons");
    const list = wrap?.querySelector(".cn-addon__list");
    if (!wrap || !list) return;

    if (!document.documentElement.classList.contains("buyflow")) {
      wrap.hidden = true;
      list.innerHTML = "";
      return;
    }

    const keysJSON = JSON.stringify(getKeys());
    if (!force && keysJSON === lastKeysJSON) {
      keepOpen();
      return;
    }
    lastKeysJSON = keysJSON;

    const keys = JSON.parse(keysJSON);
    if (!keys.length) {
      wrap.hidden = true;
      list.innerHTML = "";
      keepOpen();
      return;
    }

    const c = await cart();
    const items = (c.items || []).filter((x) => keys.includes(x.key));
    if (!items.length) {
      wrap.hidden = true;
      list.innerHTML = "";
      keepOpen();
      return;
    }

    list.innerHTML = items
      .map((x) => {
        const img = x.image || x.featured_image?.url || x.featured_image;
        const spec = [];
        if (x.variant_title && x.variant_title !== "Default Title")
          spec.push(x.variant_title);

        return `
        <div class="cn-addon__item" data-line-key="${x.key}" data-variant-id="${
          x.variant_id
        }">
          <div class="upsell-modal-notif">
            <div class="cart-notification-product__image global-media-settings">
              ${
                img
                  ? `<img src="${img}" alt="" width="70" height="101" loading="lazy">`
                  : ""
              }
            </div>
            <div class="product-info-wrapper">
              <div class="cart-notification-product__name h4" style="color:#3c3c3c; font-weight:600;">${
                x.product_title
              }</div>
              <div class="product-option">${spec}</div>
              <div class="cart-item-bottom">
                <p class="cart-item-price-qty">Qty: ${x.quantity} • ${fmtMoney(x.final_line_price)}</p>
              </div>
            </div>
          </div>
          <div class="cn-addon__actions">
            <div class="cn-addon__price"></div>
            <button class="cn-addon__remove" type="button">
              <svg width="15" height="15" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 2.5H9M4 4.5V7.5M6 4.5V7.5M1.5 2.5L2 8.5C2 8.76522 2.10536 9.01957 2.29289 9.20711C2.48043 9.39464 2.73478 9.5 3 9.5H7C7.26522 9.5 7.51957 9.39464 7.70711 9.20711C7.89464 9.01957 8 8.76522 8 8.5L8.5 2.5M3.5 2.5V1C3.5 0.867392 3.55268 0.740215 3.64645 0.646447C3.74021 0.552678 3.86739 0.5 4 0.5H6C6.13261 0.5 6.25979 0.552678 6.35355 0.646447C6.44732 0.740215 6.5 0.867392 6.5 1V2.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>`;
      })
      .join("");

    wrap.hidden = false;
    keepOpen();
  }

  document.addEventListener(
    "click",
    (e) => {
      const checkoutBtn = e.target.closest(
        "#cart-notification .see-cart-cta.is-checkout",
      );
      if (checkoutBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        // ✅ Redirect berdasarkan requiresForm
        if (window.__buyNowRequiresForm) {
          var url = "/pages/form-product";
          if (window.__buyNowItemKey)
            url += "?line=" + encodeURIComponent(window.__buyNowItemKey);
          window.location.href = url;
        } else {
          window.location.href = "/checkout";
        }
      }
    },
    true,
  );

  document.addEventListener("click", async (e) => {
    if (e.target.closest(".see-cart-cta.is-checkout")) return;

    const btn = e.target.closest(".js-upsell-add");
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    if (busy) return;
    busy = true;
    btn.disabled = true;

    try {
      const upsellIndex =
        btn.dataset?.upsellIndex ||
        btn.closest("[data-upsell-index]")?.dataset?.upsellIndex ||
        btn.closest(".cn-upsell")?.dataset?.upsellIndex ||
        null;

      const scope = upsellIndex
        ? document.querySelector(
            `.cn-upsell[data-upsell-index="${upsellIndex}"]`,
          )
        : btn.closest(".cn-upsell") || btn.closest("li") || btn.parentElement;

      let id =
        btn.dataset?.variantId ||
        resolveVariantId(btn) ||
        resolveVariantId(scope);
      if (!id) {
        console.error("❌ Tidak bisa resolve variant id");
        busy = false;
        btn.disabled = false;
        return;
      }

      let qty = 1;
      const inputMobile = scope?.querySelector(
        ".cn-upsell__qty-mobile .js-upsell-qty-input",
      );
      const inputDesktop = scope?.querySelector(
        ".cn-upsell__qty .js-upsell-qty-input",
      );

      if (inputMobile && inputMobile.offsetParent !== null)
        qty = parseInt(inputMobile.value || "1", 10);
      else if (inputDesktop && inputDesktop.offsetParent !== null)
        qty = parseInt(inputDesktop.value || "1", 10);
      qty = Number.isFinite(qty) && qty > 0 ? qty : 1;

      const c = await cart();
      const existing = (c.items || []).find(
        (x) => String(x.variant_id) === String(id),
      );

      if (existing) {
        const newQty = existing.quantity + qty;
        await change({ key: existing.key, quantity: newQty });
        btn.dataset.lineKey = existing.key;
      } else {
        const data = await add(id, qty);
        const added = (data.items || [])[0];
        if (added?.key) {
          addKey(added.key);
          btn.dataset.lineKey = added.key;
        }
      }

      btn.textContent = "+ Keranjang";
      btn.classList.remove("is-added");

      if (typeof openModal === "function") openModal();

      await bubble();
      await renderAddons(true);
      keepOpen();
    } catch (err) {
      console.error("❌ Upsell add error", err);
      keepOpen();
    } finally {
      busy = false;
      btn.disabled = false;
    }
  });

  document.addEventListener("click", (e) => {
    const qtyBtn = e.target.closest(".js-upsell-qty");
    if (!qtyBtn) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    const scope = qtyBtn.closest(".cn-upsell");
    if (!scope) return;

    // cek apakah tombol ada di blok desktop atau mobile
    let input;
    if (qtyBtn.closest(".cn-upsell__qty-mobile")) {
      input = scope.querySelector(
        ".cn-upsell__qty-mobile .js-upsell-qty-input",
      );
    } else {
      input = scope.querySelector(".cn-upsell__qty .js-upsell-qty-input");
    }
    if (!input) return;

    let val = parseInt(input.value || "1", 10);
    const delta = parseInt(qtyBtn.dataset.delta, 10) || 0;
    val = Math.max(1, val + delta);
    input.value = val;

    const addBtn = scope.querySelector(".js-upsell-add");
    if (addBtn) addBtn.dataset.quantity = val;

    scope.querySelectorAll(".cn-upsell__price").forEach((priceEl) => {
      const base = parseInt(priceEl.dataset.basePrice || "0", 10);
      const total = base * val;
      const moneyEl = priceEl.querySelector(".money, .money-mobile");
      if (moneyEl) {
        moneyEl.textContent = fmtMoney(total);
      }
    });
  });

  document.addEventListener("click", async (e) => {
    const rm = e.target.closest("#cart-notification-addons .cn-addon__remove");
    if (!rm) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    if (busy) return;
    busy = true;
    rm.disabled = true;

    try {
      const row = rm.closest(".cn-addon__item");
      const key = row?.dataset.lineKey;
      const vid = row?.dataset.variantId;

      await change({ id: vid, key, quantity: 0 });
      if (key) delKey(key);

      await bubble();
      await renderAddons(true);

      const up = document.querySelector(
        `.js-upsell-add[data-variant-id="${vid}"]`,
      );
      if (up) {
        up.classList.remove("is-added");
        up.textContent = "+ Keranjang";
        up.removeAttribute("data-line-key");
      }
      keepOpen();
    } catch (err) {
      console.error("❌ remove addon error", err);
      keepOpen();
    } finally {
      busy = false;
      rm.disabled = false;
    }
  });

  document.addEventListener("cn:sync-cta", () => {
    renderAddons(true);
    keepOpen();
  });

  document.addEventListener("change", (e) => {
    const sel = e.target.closest(".js-upsell-opt");
    if (!sel) return;

    const upsellIndex =
      sel.closest("[data-upsell-index]")?.dataset?.upsellIndex ||
      sel.closest(".cn-upsell")?.dataset?.upsellIndex ||
      null;
    if (!upsellIndex) {
      console.error(
        "❌ Tidak dapat temukan data-upsell-index pada select",
        sel,
      );
      return;
    }

    const scope = document.querySelector(
      `.cn-upsell[data-upsell-index="${upsellIndex}"]`,
    );
    if (!scope) {
      console.error(
        "❌ Tidak dapat temukan scope .cn-upsell untuk index",
        upsellIndex,
      );
      return;
    }

    const variantDataEl = scope.querySelector(".cn-upsell-variants-full");
    if (!variantDataEl) return;
    let variants = [];
    try {
      variants = JSON.parse(variantDataEl.textContent || "[]");
    } catch (err) {
      console.error("❌ Gagal parse JSON varian", err);
      return;
    }

    const sortSelects = (nodeList) =>
      Array.from(nodeList).sort((a, b) => {
        const ai =
          parseInt(a.dataset.optIndex ?? a.getAttribute("data-opt-index")) || 0;
        const bi =
          parseInt(b.dataset.optIndex ?? b.getAttribute("data-opt-index")) || 0;
        return ai - bi;
      });

    const desktopContainer = scope.querySelector(".cn-upsell__options");
    const desktopSelects = desktopContainer
      ? sortSelects(desktopContainer.querySelectorAll(".js-upsell-opt"))
      : [];

    const mobileBlock = document.querySelector(
      `.cn-upsell__options-mobile[data-upsell-index="${upsellIndex}"]`,
    );
    const mobileSelects = mobileBlock
      ? sortSelects(mobileBlock.querySelectorAll(".js-upsell-opt"))
      : [];

    const sourceIsMobile = !!sel.closest(".cn-upsell__options-mobile");
    const sourceSelects = sourceIsMobile
      ? mobileSelects
      : desktopSelects.length
        ? desktopSelects
        : mobileSelects;

    const selectedOptions = sourceSelects.map((s) =>
      s.value != null ? String(s.value) : "",
    );

    let match = null;
    if (selectedOptions.length) {
      match = variants.find(
        (v) =>
          Array.isArray(v.options) &&
          v.options.length === selectedOptions.length &&
          v.options.every(
            (opt, i) => String(opt || "") === String(selectedOptions[i] || ""),
          ),
      );
    }
    if (!match && selectedOptions.length) {
      match = variants.find((v) =>
        selectedOptions.every((so) =>
          (v.options || [])
            .map((o) => String(o || ""))
            .includes(String(so || "")),
        ),
      );
    }
    if (!match && variants.length) {
      match = variants[0];
    }
    if (!match) return;

    if (sourceIsMobile && desktopSelects.length)
      copySelectValues(mobileSelects, desktopSelects);
    if (!sourceIsMobile && mobileSelects.length)
      copySelectValues(desktopSelects, mobileSelects);

    scope.querySelectorAll(".js-upsell-add").forEach((btn) => {
      btn.setAttribute("data-variant-id", match.id);
      btn.dataset.variantId = match.id;
    });
    const mobileBtn = document.querySelector(
      `.js-upsell-add[data-upsell-index="${upsellIndex}"]`,
    );
    if (mobileBtn) {
      mobileBtn.setAttribute("data-variant-id", match.id);
      mobileBtn.dataset.variantId = match.id;
    }

    let qty = 1;
    const inputMobile = scope.querySelector(
      ".cn-upsell__qty-mobile .js-upsell-qty-input",
    );
    const inputDesktop = scope.querySelector(
      ".cn-upsell__qty .js-upsell-qty-input",
    );
    if (inputMobile && inputMobile.offsetParent !== null)
      qty = parseInt(inputMobile.value || "1", 10);
    else if (inputDesktop && inputDesktop.offsetParent !== null)
      qty = parseInt(inputDesktop.value || "1", 10);
    qty = Number.isFinite(qty) && qty > 0 ? qty : 1;

    scope.querySelectorAll(".cn-upsell__price").forEach((priceEl) => {
      priceEl.dataset.basePrice = match.price;
      const moneyEls = priceEl.querySelectorAll(".money, .money-mobile");
      moneyEls.forEach((moneyEl) => {
        moneyEl.textContent = fmtMoney(match.price * qty);
      });
    });

    scope.querySelectorAll(".js-upsell-add").forEach((btn) => {
      btn.dataset.quantity = qty;
    });
    if (mobileBtn) mobileBtn.dataset.quantity = qty;
  });

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".cn-upsell").forEach((scope) => {
      const newId = resolveVariantId(scope);
      if (newId) {
        scope.querySelectorAll(".js-upsell-add").forEach((btn) => {
          btn.setAttribute("data-variant-id", newId);
          btn.dataset.variantId = newId;
        });

        const idx = scope.dataset?.upsellIndex;
        if (idx) {
          const mobileBtn = document.querySelector(
            `.js-upsell-add[data-upsell-index="${idx}"]`,
          );
          if (mobileBtn) {
            mobileBtn.setAttribute("data-variant-id", newId);
            mobileBtn.dataset.variantId = newId;
          }
        }
      }

      const priceEls = scope.querySelectorAll(".cn-upsell__price");
      priceEls.forEach((priceEl) => {
        const base = parseInt(priceEl.dataset.basePrice || "0", 10);
        const moneyEls = priceEl.querySelectorAll(".money, .money-mobile");
        moneyEls.forEach((m) => {
          m.textContent = fmtMoney(base);
        });
      });
    });
  });
})();

(function () {
  let initialized = false;

  function openModal() {
    const host = document.querySelector("cart-notification");
    const panel = document.getElementById("cart-notification");
    if (!host || !panel) return;
    host.classList.add("is-visible");
    panel.classList.add("active");
    document.documentElement.classList.add("cn-open");
  }

  function init() {
    if (initialized) return;
    initialized = true;

    document.addEventListener("cart:added", openModal);

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        document.querySelector(".cart-notification__close")?.click();
      }
    });
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);

  window.openModal = openModal;
})();

document.addEventListener("click", (e) => {
  const closeBtn = e.target.closest(".cart-notification__close");
  if (!closeBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const host = document.querySelector("cart-notification");
  const panel = document.getElementById("cart-notification");
  if (host && panel) {
    host.classList.remove("is-visible");
    panel.classList.remove("active");
    document.documentElement.classList.remove("cn-open", "buyflow");
  }
});

(() => {
  const CHECKOUT_URL = "/checkout";
  let adding = false;

  const $ = (s, r = document) => r.querySelector(s);

  const escapeHTML = (s = "") =>
    s.replace(
      /[&<>"']/g,
      (m) =>
        ({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#039;",
        })[m] || m,
    );
  const money = (cents = 0) =>
    "Rp " +
    ((cents || 0) / 100).toLocaleString("id-ID", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  async function updateBubble() {
    try {
      const res = await fetch("/?sections=cart-icon-bubble").then((r) =>
        r.json(),
      );
      const bub = $("#cart-icon-bubble");
      if (bub && res["cart-icon-bubble"])
        bub.innerHTML = res["cart-icon-bubble"];
    } catch {}
  }

  function renderCustomSummary(added) {
    const host = $("#cart-notification-product");
    if (!host) return;

    const img =
      added.image ||
      (added.featured_image &&
        (added.featured_image.url || added.featured_image)) ||
      "";
    const title = escapeHTML(added.product_title || added.title || "");
    const varTitle =
      added.variant_title && added.variant_title !== "Default Title"
        ? escapeHTML(added.variant_title)
        : "";
    const qty = added.quantity || 1;
    const total =
      added.final_line_price ?? (added.final_price ?? added.price ?? 0) * qty;

    host.innerHTML = `
      <div class="wrapper-cart-notification-product">
        <div class="cart-notification-product__image global-media-settings">
          ${
            img
              ? `<img src="${img}" alt="" width="70" height="101" loading="lazy">`
              : ""
          }
        </div>
        <div class="product-info-wrapper">
          <div class="cart-notification-product__name h4">${title}</div>
          <div class="product-option">${varTitle ? `${varTitle}` : ""}</div>
          <div class="cart-item-bottom">
            <p class="cart-item-price-qty">Qty: ${qty} • ${money(total)}</p>
          </div>
        </div>
      </div>
      <div class="cart-see-cart"></div>
    `;

    document.dispatchEvent(new CustomEvent("cn:sync-cta"));
    document.dispatchEvent(new CustomEvent("cn:sync-wrapper"));
  }

  function openModal() {
    const host = $("cart-notification");
    const panel = $("#cart-notification");
    if (!host || !panel) return;

    if (
      document.documentElement.classList.contains("buyflow") &&
      host.classList.contains("is-visible")
    ) {
      return;
    }

    panel.classList.add("active");
    host.classList.add("is-visible");
    document.documentElement.classList.add("cn-open");
  }

  async function addMainFromForm(form, requiresForm) {
    if (adding) return;
    adding = true;
    try {
      // ✅ Step 1: Clear cart dulu supaya tidak campur produk lain
      await fetch("/cart/clear.js", {
        method: "POST",
        headers: { Accept: "application/json" },
      });

      // ✅ Step 2: Add produk ini saja
      const fd = new FormData(form);
      const res = await fetch("/cart/add.js", {
        method: "POST",
        body: fd,
        headers: { Accept: "application/json" },
      });
      if (!res.ok) throw new Error("add fail");

      const json = await res.json();
      const added = Array.isArray(json?.items) ? json.items[0] : json;

      // ✅ Simpan requiresForm & item key untuk dipakai saat close popup
      window.__buyNowRequiresForm = requiresForm === true;
      window.__buyNowItemKey = added?.key || null;

      document.documentElement.classList.add("buyflow");
      openModal();
      renderCustomSummary(added);
      updateBubble();
    } catch {
      document.documentElement.classList.add("buyflow");
      openModal();
      document.dispatchEvent(new CustomEvent("cn:sync-cta"));
    } finally {
      adding = false;
    }
  }

  // fungsi menampilkan upsell buy now
  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest(
        '.shopify-payment-button__button, .shopify-payment-button__button--unbranded, button[name="buy"], [data-buynow], a[href*="/checkout"]:not([href*="/cart"])',
      );
      if (!btn) return;

      const hasUpsell = !!document.querySelector(".cn-upsell");
      if (!hasUpsell) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      // ✅ Ambil requiresForm dari data attribute tombol Buy Now
      const requiresForm = btn.dataset?.requiresForm === "true";

      const scope =
        btn.closest("product-form") || document.querySelector("product-form");
      const form =
        scope?.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]');

      if (form) addMainFromForm(form, requiresForm);
      else {
        window.__buyNowRequiresForm = requiresForm;
        window.__buyNowItemKey = null;
        openModal();
        renderCustomSummary(null);
        updateBubble();
      }
    },
    true,
  );

  // ✅ Helper: tentukan URL redirect saat keluar dari popup (close / escape / checkout CTA)
  function getBuyNowRedirectURL() {
    if (window.__buyNowRequiresForm) {
      var url = "/pages/form-product";
      if (window.__buyNowItemKey)
        url += "?line=" + encodeURIComponent(window.__buyNowItemKey);
      return url;
    }
    return CHECKOUT_URL;
  }

  document.addEventListener(
    "click",
    (e) => {
      if (!document.documentElement.classList.contains("buyflow")) return;
      if (e.target.closest("#cart-notification .cart-notification__close")) {
        e.preventDefault();
        window.location.assign(getBuyNowRedirectURL());
      }
    },
    true,
  );
  document.addEventListener("keydown", (e) => {
    if (
      document.documentElement.classList.contains("buyflow") &&
      e.key === "Escape"
    ) {
      e.preventDefault();
      window.location.assign(getBuyNowRedirectURL());
    }
  });

  window.renderCustomSummary = renderCustomSummary;
  window.updateBubble = updateBubble;
  window.openModal = openModal;
})();

document.addEventListener(
  "submit",
  (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();

    const fd = new FormData(form);

    fetch("/cart/add.js", {
      method: "POST",
      body: fd,
      headers: { Accept: "application/json" },
    })
      .then((r) => r.json())
      .then((json) => {
        const added = Array.isArray(json?.items) ? json.items[0] : json;
        if (typeof openModal === "function") openModal();
        renderCustomSummary(added);
        updateBubble();
        document.dispatchEvent(new CustomEvent("cn:sync-cta"));
      })
      .catch(() => {
        if (typeof openModal === "function") openModal();
        document.dispatchEvent(new CustomEvent("cn:sync-cta"));
      });
  },
  true,
);

(function () {
  const CART_URL = (window.routes && window.routes.cart_url) || "/cart";
  const CHECKOUT_URL =
    (window.routes && window.routes.checkout_url) || "/checkout";
  const isBuyflow = () =>
    document.documentElement.classList.contains("buyflow");

  function markSummary() {
    const root = document.getElementById("cart-notification-product");
    if (!root) return;
    const firstVisible = [...root.children].find(
      (el) => el.nodeType === 1 && el.offsetParent !== null,
    );
    if (firstVisible) firstVisible.classList.add("cn-summary");
  }

  function syncResponsiveWrapper() {
    const root = document.getElementById("cart-notification-product");
    if (!root) return;

    const isMobile = window.matchMedia("(max-width: 480px)").matches;
    const wrapper = root.querySelector(".upsell-modal-notif");

    if (isMobile) {
      if (!wrapper) {
        const img = root.querySelector(".cart-notification-product__image");
        const info = root.querySelector(".product-info-wrapper");
        if (!img || !info) return;

        const w = document.createElement("div");
        w.className = "upsell-modal-notif cn-summary";
        root.insertBefore(w, img);
        w.appendChild(img);
        w.appendChild(info);
      }
    } else if (wrapper) {
      const img = wrapper.querySelector(".cart-notification-product__image");
      const info = wrapper.querySelector(".product-info-wrapper");
      if (img) root.insertBefore(img, wrapper);
      if (info) root.insertBefore(info, wrapper.nextSibling);
      wrapper.remove();

      [...root.children].forEach((el) => el.classList?.remove("cn-summary"));
      markSummary();
    }
  }

  let syncTimeout;
  const debouncedSyncWrapper = () => {
    clearTimeout(syncTimeout);
    syncTimeout = setTimeout(syncResponsiveWrapper, 10);
  };

  function syncCTA() {
    const host = document.getElementById("cart-notification-product");
    if (!host) return;

    let row = host.querySelector(".cart-see-cart");
    if (!row) {
      row = document.createElement("div");
      row.className = "cart-see-cart";
      host.appendChild(row);
    }

    let a = row.querySelector(".see-cart-cta");
    if (!a) {
      a = document.createElement("a");
      a.className = "see-cart-cta";
      row.appendChild(a);
    }

    if (isBuyflow()) {
      // ✅ Gunakan URL yang sesuai requiresForm
      const redirectURL = (() => {
        if (window.__buyNowRequiresForm) {
          let u = CART_URL.replace("/cart", "/pages/form-product");
          u = "/pages/form-product";
          if (window.__buyNowItemKey)
            u += "?line=" + encodeURIComponent(window.__buyNowItemKey);
          return u;
        }
        return CHECKOUT_URL;
      })();
      a.href = redirectURL;
      a.textContent = "Checkout";
      a.classList.add("is-checkout");
      a.classList.remove("is-cart");
      const footer = document.querySelector(
        "#cart-notification .cart-notification__links",
      );
      if (footer) footer.style.display = "none";
    } else {
      a.href = CART_URL;
      a.textContent = "Lihat Keranjang";
      a.classList.add("is-cart");
      a.classList.remove("is-checkout");
      const footer = document.querySelector(
        "#cart-notification .cart-notification__links",
      );
      if (footer) footer.style.removeProperty("display");
    }
  }

  function init() {
    const panel = document.getElementById("cart-notification");
    if (!panel) return;

    const run = () => {
      if (panel.classList.contains("active")) {
        setTimeout(() => {
          debouncedSyncWrapper();
          markSummary();
          syncCTA();
        }, 0);
      }
    };

    run();

    new MutationObserver(run).observe(panel, {
      attributes: true,
      attributeFilter: ["class"],
    });

    new MutationObserver(syncCTA).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    const productRoot = document.getElementById("cart-notification-product");
    if (productRoot) {
      new MutationObserver(debouncedSyncWrapper).observe(productRoot, {
        childList: true,
      });
    }

    document.addEventListener("cn:sync-cta", () => setTimeout(syncCTA, 0));
    document.addEventListener("cn:sync-wrapper", debouncedSyncWrapper);
    window.addEventListener("resize", debouncedSyncWrapper);
  }

  if (document.readyState !== "loading") {
    init();
    debouncedSyncWrapper();
    markSummary();
    syncCTA();
  } else {
    document.addEventListener("DOMContentLoaded", () => {
      init();
      debouncedSyncWrapper();
      markSummary();
      syncCTA();
    });
  }
})();
